import { WikiPage } from "./WikiPage";

const GuidePage = () => {
  return <WikiPage slug="code-os-guide" />;
};

export { GuidePage };
